






























import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class DsConfDetail extends Vue {
  @Prop() dsConfig!: any;
}
